/**
 * payment-ledger-api から popopo-msg が参照している型のインライン定義。
 * popopo-msg は配布パッケージとして外部リポジトリに同期されるため、
 * workspace 依存を避ける必要がある。
 *
 * ここには popopo-msg の Firestore ドキュメント定義で必要な
 * Scope, IABProduct, IAPProduct, IABPurchaseId, IAPPurchaseId のみを含む。
 */
import { z } from "zod/v4"
import type { Tagged } from "./tag"

export enum Scope {
  Free = 0,
  IAP = 1,
  IAB = 2,
  Web = 3,
  Compensation = 4,
}

export type IABPurchaseId = Tagged<"iab_purchase", string>

export const IABProduct = z.object({
  packageName: z.string(),
  productId: z.string(),
})

export type IABProduct = z.infer<typeof IABProduct>

export type IAPPurchaseId = Tagged<"iap_purchase", string>

export const IAPProduct = z.object({
  productId: z.string(),
  bundleId: z.string(),
  appAppleId: z.number().optional(),
})

export type IAPProduct = z.infer<typeof IAPProduct>
